import React from "react"
import { withPrefix } from "gatsby"

export default function HeaderMenu() {
	
  const style2 = {padding: "9px 11px"};
  const style3 = {fontSize: "20px"};
  const style4 = {paddingLeft: "22px"};
	
  return (
    <div id="headerMenu">
		<div className="mobile-menu bgclr3"  role="menubar">
			<li className="leftMenu" style={style4}>
				<a href="mailto:praveen@weberealty.com">
					<i className="fa fa-envelope icon"></i>	
				</a>
			</li>
			<li className="leftMenu">
				<a href="tel:925-452-7483">
					<i className="fa fa-phone icon"></i>	
				</a>
			</li>	
			<li className="mobile-menu-button" style={style2}><i className="fa fa-bars" style={style3}></i></li>
		</div>
		
		<nav id="navBar" className="bgclr3">
			<ul className="leftMenu">
				<li>
					<a href="mailto:praveen@weberealty.com">
						<i className="fa fa-envelope icon"></i>
						<span className="aText"> Email</span>	
					</a>
				</li>
				<li>
					<a href="tel:925-452-7483">
						<i className="fa fa-phone icon"></i>
						<span className="aText"> 925-452-7483</span> 	
					</a>
				</li>
			</ul>

			<ul className="menu container rightMenu" role="menubar" >

				<li className="bgclr3" role="menuitem">
					<a href="/index.html">HOME</a>
				</li>

				<li className="bgclr3" role="menuitem">
					<a className="menu-head" href="/south_bay.html">MORE<span className="triangle-bottom"></span></a>
					<div className="sub-menu">
						<div className="container bgclr3">
							<div>
								<ul role="menu">
									<li role="menuitem"><a href="/buyers.html">Buyers Resources</a></li>
									<li role="menuitem"><a href="/sellers.html">Seller Resources</a></li>
									<li role="menuitem"><a href="/whyfree.html">Why Is This Info Free?</a></li>
									<li role="menuitem"><a href="/insideraccess.html">Get VIP Insider Access</a></li>
									<li role="menuitem"><a href="/gold_newsletter.html">This Month's Newsletter</a></li>
									<li role="menuitem"><a href="/agent_questions.html">Questions Agents Hate!</a></li>
								</ul>
							</div>
						</div>
					</div>
				</li>

				<li className="bgclr3" role="menuitem">
					<a className="menu-head" href="/buyers.html">Buyers<span className="triangle-bottom"></span></a>
					<div className="sub-menu">
						<div className="container bgclr3">
							<div>
								<ul role="menu">
									<li role="menuitem"><a href="/vip_buyer.html">Get Hot NEW Listings</a></li>
									<li role="menuitem"><a href="/gold_distress.html">Foreclosures Hot List</a></li>
									<li role="menuitem"><a href="/stop_renting.html">Stop Paying Rent</a></li>
									<li role="menuitem"><a href="/trade_up.html">Moving Up?</a></li>
									<li role="menuitem"><a href="/seminar_13costs.html">Beware! 13 Extra Costs</a></li>
									<li role="menuitem"><a href="/buyertraps.html">9 Common Buyer Traps</a></li>
									<li role="menuitem"><a href="/zerodown.html">Buy with ZERO Down</a></li>
									<li role="menuitem"><a href="/savethousands.html">Save Thousands</a></li>
									<li role="menuitem"><a href="/buyer_mistakes.html">6 Buyer Mistakes</a></li>
									<li role="menuitem"><a href="/gc_fixermyths.html">Fixer Uppers: Myths &amp; Facts</a></li>
									<li role="menuitem"><a href="/gc_bestbuys.html">10 Best Buys Hotlist</a></li>
									<li role="menuitem"><a href="/gc_firsttime.html">First Time Buyer Hotlist</a></li>
									<li role="menuitem"><a href="/gc_nomoneydown.html">No Money Down Hotlist</a></li>
									<li role="menuitem"><a href="/gc_upscale.html">Upscale Homes Hotlist</a></li>
									<li role="menuitem"><a href="/gc_fixerupper.html">Fixer Uppers Hotlist</a></li>
								</ul>
							</div>
						</div>
					</div>
				</li>

				<li className="bgclr3" role="menuitem">
					<a className="menu-head" href="/sellers.html">Sellers<span className="triangle-bottom"></span></a>
					<div className="sub-menu">
						<div className="container bgclr3">
							<div>	
								<ul role="menu">
									<li role="menuitem"><a href="/24h-guarantee.html">Get Cash Offer within 24 hours</a></li>
									<li role="menuitem"><a href="/homeeval.html">What's Your Home Worth?</a></li>
									<li role="menuitem"><a href="/seller_mistakes.html">Avoid These Mistakes</a></li>
									<li role="menuitem"><a href="/gold_findout.html">Prices In Your Area</a></li>
									<li role="menuitem"><a href="/27tips.html">27 Seller Tips</a></li>
									<li role="menuitem"><a href="/sell_for_more.html">How To Sell For More!</a></li>
									<li role="menuitem"><a href="/inspection.html">Pass Your Inspection</a></li>
									<li role="menuitem"><a href="/seminar_divorce.html">Divorce and Your Home</a></li>
									<li role="menuitem"><a href="/silver_fsbo.html">For Sale by Owner</a></li>
									<li role="menuitem"><a href="/gold_howlong.html">When Will It Sell?</a></li>
									<li role="menuitem"><a href="/coaching_emptynest.html">Emptying the Nest?</a></li>
									<li role="menuitem"><a href="/coaching_negotiating.html">Getting the Best Price</a></li>
									<li role="menuitem"><a href="/coaching_setprice.html">Getting YOUR Price</a></li>
									<li role="menuitem"><a href="/seminar_expired.html">Your House Didn't Sell</a></li>
									<li role="menuitem"><a href="/coaching_legal.html">Avoid Legal Mistakes</a></li>
								</ul>
							</div>
						</div>
					</div>
				</li>

				<li className="bgclr3" role="menuitem">
					<a className="menu-head" href="/contact.html">Contact<span className="triangle-bottom"></span></a>
					<div className="sub-menu">
						<div className="container bgclr3">
							<div>
								<ul role="menu">
									<li role="menuitem"><a href="/contact.html">Contact Us</a></li>
									<li role="menuitem"><a href="/gold_referral.html">Refer a Friend</a></li>
								</ul>
							</div>
						</div>
					</div>
				</li>

				<li className="bgclr3" role="menuitem">
					<a href={withPrefix('/blog')}>Blog</a>
				</li>
				
			</ul>
		</nav>
	</div>
  )
}